export const darkenColor = (hex, percent = 30) => {
  // Aumentado a 15%
  if (!hex) return undefined;

  // Convertir a RGB
  let r = parseInt(hex.slice(1, 3), 16);
  let g = parseInt(hex.slice(3, 5), 16);
  let b = parseInt(hex.slice(5, 7), 16);

  // Oscurecer cada componente
  r = Math.max(0, Math.floor((r * (100 - percent)) / 100));
  g = Math.max(0, Math.floor((g * (100 - percent)) / 100));
  b = Math.max(0, Math.floor((b * (100 - percent)) / 100));

  // Convertir de vuelta a hexadecimal
  return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
};